import React from "react";
import TimePicker from "material-ui/TimePicker";
import TimePickerNew from "@techsoftware/happay-widgets/TimePicker";

import classNames from "classnames";
import i18n from "../i18nNext";

export default class CustomTime extends React.Component {
    constructor(props) {
        super(props);
        this._timeIconClick = this._timeIconClick.bind(this);
        this._onChange = this._onChange.bind(this);
        this._clearTime = this._clearTime.bind(this);
    }

    _timeIconClick() {
        if (this.customTimePicker && !this.props.disabled) {
            this.customTimePicker.focus();
        }
    }

    _onChange(event, value) {
        if (this.props.onChange) {
            this.props.onChange(null, value);
        }
    }

    _clearTime(event) {
        event.preventDefault();
        if (this.props.onChange && !this.props.disabled) this.props.onChange(null, null);
    }

    render() {
        const {
            required,
            disabled,
            hideUnderline,
            value,
            id,
            className,
            style,
            textFieldStyle,
            iconStyle,
            autoOk,
            format,
            floatingLabelText,
            errorText,
            ref,
            removeMargin
        } = this.props;
        const val = JSON.stringify(value || {});
        const cursor = disabled ? "no-drop" : "pointer";
        const idObj = { id };
        if (this.props.isWidgetComp) {
            return (
                <TimePickerNew
                    autoOk={autoOk}
                    ref={ref || "timepickerRef"}
                    required={required}
                    // format24={format || false}
                    format={format || false}
                    disabled={disabled}
                    labelValue={floatingLabelText}
                    value={val}
                    onChange={this.props.onChange}
                    style={style}
                    errorText={errorText}
                    parentWrapperClass={removeMargin ? "" : "hw-customTextInput-wrapper"}
                    borderType={"light"}
                    isEditable
                    isClearable
                    {...this.props}
                />
            );
        }
        return (
            <div {...idObj} style={{ position: "relative" }}>
                <TimePicker
                    {...this.props}
                    ref={input => (this.customTimePicker = input)}
                    className={classNames(
                        "customTimepicker",
                        { "hide-underline": hideUnderline, labelForDateHint: val === "{}" },
                        className
                    )}
                    style={{
                        width: "100%",
                        display: "inline-flex",
                        ...style
                    }}
                    floatingLabelStyle={{ fontWeight: "normal", fontSize: 16 }}
                    textFieldStyle={{
                        width: "110%",
                        fontSize: 12,
                        color: "#54698d",
                        fontFamily: "Roboto-Regular",
                        opacity: disabled ? "0.5" : 1,
                        ...textFieldStyle
                    }}
                    value={value || null}
                    onChange={this._onChange}
                    format={i18n.language.includes("en") ? "ampm" : "24hr"}
                    locale={i18n.language}
                    okLabel={i18n.t("btn.ok")}
                    cancelLabel={i18n.t("btn.cancel")}
                    dialogStyle={{ zIndex: 2000 }}
                />
                {required || val === "{}" ? (
                    <img
                        onClick={this._timeIconClick}
                        style={{
                            position: "absolute",
                            cursor: "pointer",
                            bottom: "12px",
                            right: "4px",
                            ...iconStyle
                        }}
                        src="/assets/images/time-icon.svg"
                        height="15"
                        width="15"
                    />
                ) : (
                    !required && (
                        <img
                            onClick={this._clearTime}
                            style={Object.assign(
                                {
                                    position: "absolute",
                                    cursor: cursor,
                                    bottom: "15px",
                                    right: "4px",
                                    width: "10px"
                                },
                                iconStyle
                            )}
                            src="/assets/images/date-clear-icon.svg"
                        />
                    )
                )}
            </div>
        );
    }
}
